import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateAccommodationContact($companyId: ID!, $id: ID!, $attributes: AccommodationContactAttributes!) {
    updateAccommodationContact(companyId: $companyId, id: $id, attributes: $attributes) {
      accommodationContact {
        id
        ...UpdatedAccommodationContact
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedAccommodationContact on AccommodationContact {
    id
    name
    email
    phone
    color
    contactType
    user { id displayName email }
    accommodation { id }
  }
`
